import React, { useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';

interface DeleteConfirmationWithReasonProps {
  CancelButtonText?: string;
  ConfirmDelete: (Id: string, reason: string) => void;
  DeleteButtonText?: string;
  HideModal: () => void;
  Id: string;
  Message: string;
  ShowModal: boolean;
  Title?: string;
}

const DeleteConfirmationWithReason = ({
  CancelButtonText = 'Peruuta ja sulje',
  ConfirmDelete,
  DeleteButtonText = 'Poista',
  HideModal,
  Id,
  Message,
  ShowModal,
  Title = 'Poiston varmistaminen',
}: DeleteConfirmationWithReasonProps) => {
  const [reason, setReason] = useState('');
  const handleConfirmDelete = () => {
    ConfirmDelete(Id, reason);
  };

  return (
    <Modal show={ShowModal} centered>
      <Modal.Body className="px-24 py-40 px-lg-40">
        <h3 className="h4 mb-16">{Title}</h3>
        <p className="mb-0">{Message}</p>
        <Form.Group controlId="reasonInput" className="mt-3">
          <Form.Label>Peruutuksen syy</Form.Label>
          <Form.Control
            type="text"
            required
            value={reason}
            onChange={e => setReason(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="border-0 bg-light p-24">
        <Button variant="link" onClick={() => HideModal()} className="px-32">
          {CancelButtonText}
        </Button>
        <Button
          variant="danger"
          onClick={handleConfirmDelete}
          className="px-32"
          disabled={!reason.trim()}
        >
          {DeleteButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationWithReason;
export { DeleteConfirmationWithReason };
export type { DeleteConfirmationWithReasonProps };
